import { Icon } from '../ui/Icon'
import '../agents/bookmarks/bookmarks.css'

/**
 * The bookmark on a project's message (owner, 2026-11-01: 我們在 project 裡面也可以加入書籤 … 這個書籤就只有該使用者自己可以
 * 看到). Clean View's button (agents/bookmarks/BookmarkButton), at the end of the message's reactions row: always there
 * — a door a phone has to find (owner, 2026-10-31: 不要隱藏 message box 的書簽小按鈕) — muted until kept, yellow when kept.
 */
export function RoomBookmarkButton({ state, onToggle }: { state: 'kept' | 'pending' | null; onToggle: () => void }) {
  const on = state !== null
  return (
    <button
      type="button"
      className={`bm-btn bm-in-rx${on ? ' on' : ''}`}
      aria-pressed={on}
      aria-label={on ? 'Remove this message from your bookmarks' : 'Bookmark this message (only you see it)'}
      title={on ? 'Bookmarked — tap to remove' : 'Bookmark this message — only you see it'}
      disabled={state === 'pending'}
      onClick={onToggle}
    >
      <Icon name={on ? 'bookmark_filled' : 'bookmark'} size={16} />
    </button>
  )
}
